import { getInitials, avatarClass } from '@/pages/home/activityMeta';

interface ParticipantsPanelProps {
  organizer: string;
  participants: string[];
  maxParticipants: number | null;
  isHelp: boolean;
  isPublishedByYonYon: boolean;
}

export default function ParticipantsPanel({ organizer, participants, maxParticipants, isHelp, isPublishedByYonYon }: ParticipantsPanelProps) {
  const total = participants.length;
  const remaining = maxParticipants !== null ? maxParticipants - total : null;

  return (
    <section className="bg-white border border-background-200 rounded-lg p-5">
      <div className="flex items-center justify-between px-3 py-1.5 sm:bg-none sm:px-0 sm:py-0">
        <h2 className="font-heading text-lg font-semibold text-[#432820]">
          {isHelp ? 'En contact' : 'Participants'}
        </h2>

        {maxParticipants !== null && !isHelp && (
          <span className="text-xs font-semibold text-white sm:text-foreground-500">
            {total}/{maxParticipants}
          </span>
        )}
      </div>

      <div className="mt-4 flex flex-col gap-1">
        {/* Organizer */}
        <div className="flex items-center gap-3 p-2 rounded-lg bg-background-50">
          <span className={`w-10 h-10 rounded-full ${avatarClass(organizer)} flex items-center justify-center text-sm font-bold shrink-0`}>
            {getInitials(organizer)}
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-foreground-900 truncate">{organizer}</p>
            <p className="text-xs text-foreground-400">
              {isPublishedByYonYon
                ? 'Publié par'
                : isHelp
                  ? activityRoleLabel
                  : 'Organisateur'}
            </p>
          </div>
        </div>

        {/* Other participants */}
        {participants.map((name) => (
          <div key={name} className="flex items-center gap-3 p-2 rounded-lg">
            <span className={`w-10 h-10 rounded-full ${avatarClass(name)} flex items-center justify-center text-sm font-bold shrink-0`}>
              {getInitials(name)}
            </span>
            <p className="text-sm font-medium text-foreground-700 truncate">{name}</p>
          </div>
        ))}
      </div>

      {remaining !== null && remaining > 0 && !isHelp && (
        <p className="mt-4 text-xs text-foreground-500">
          Encore {remaining} place{remaining > 1 ? 's' : ''} disponible{remaining > 1 ? 's' : ''}
        </p>
      )}
      {isHelp && (
        <p className="mt-4 text-xs text-foreground-400">
          Seules les personnes ayant répondu sont visibles ici.
        </p>
      )}
    </section>
  );
}

const activityRoleLabel = 'Auteur de la demande';